import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface WindowResizeCommand {
  deviceViewEntityId: DeviceViewEntityId;
  width: number;
  height: number;
}

export const windowResize: DeviceViewCommandFactory<WindowResizeCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const foundWindow = draft.deviceViewWindows.find(
        (win) => win.id === command.deviceViewEntityId,
      );
      if (foundWindow === undefined) {
        return;
      }
      foundWindow.width = command.width;
      foundWindow.height = command.height;
    });
  };
